import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useDir } from "../../lib/useDir";
import { PageHeader, Loading, inputCls, StatCard } from "../../components/common";
import { ChartBox, VBar, HBar, Donut, TrendLine, ExpectedBars } from "../../components/Charts";
import { GroupTrends } from "../../components/GroupTrends";

export const Filters = ({ f, setF, dir, meetings }) => {
  const S = ({ k, label, opts }) => (
    <select className={`${inputCls} h-10 w-auto max-w-[220px]`} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value || undefined, ...(k === "zone_id" ? { gkk_id: undefined, unit_id: undefined } : {}), ...(k === "gkk_id" ? { unit_id: undefined } : {}) })} data-testid={`filter-${k}`}>
      <option value="">{label}</option>{opts.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {meetings && <S k="meeting_id" label="All meetings" opts={meetings.map((m) => [m.id, `${m.date} · ${m.title}`])} />}
      <input type="date" className={`${inputCls} h-10 w-auto`} value={f.date_from || ""} onChange={(e) => setF({ ...f, date_from: e.target.value || undefined })} data-testid="filter-date-from" />
      <input type="date" className={`${inputCls} h-10 w-auto`} value={f.date_to || ""} onChange={(e) => setF({ ...f, date_to: e.target.value || undefined })} data-testid="filter-date-to" />
      <S k="zone_id" label="All zones" opts={dir.zones.map((z) => [z.id, z.name])} />
      <S k="gkk_id" label="All GKKs" opts={dir.gkks.filter((g) => !f.zone_id || g.zone_id === f.zone_id).map((g) => [g.id, g.label])} />
      <S k="unit_id" label="All units" opts={dir.units.filter((u) => u.gkk_id === f.gkk_id).map((u) => [u.id, u.name])} />
      <S k="ministry_id" label="All ministries" opts={dir.ministries.map((m) => [m.id, m.name])} />
      <S k="position" label="All positions" opts={dir.positions.map((p) => [p, p])} />
      <S k="category" label="Parish & external" opts={[["parish", "Parish"], ["external", "External"]]} />
      <S k="status" label="Verified (default)" opts={["present", "late", "pending", "pre_registered", "excused", "absent", "disputed", "rejected"].map((s) => [s, s.replace("_", " ")])} />
      <button className="btn-sm btn-ghost h-10" onClick={() => setF({})} data-testid="filter-reset">Reset</button>
    </div>
  );
};

export default function Stats() {
  const { dir } = useDir();
  const [meetings, setMeetings] = useState([]);
  const [f, setF] = useState({});
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/meetings").then((r) => setMeetings(r.data)); }, []);
  useEffect(() => {
    const load = () => api.get("/stats/overview", { params: f }).then((r) => setD(r.data));
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [f]);
  if (!dir || !d) return <Loading />;
  return (
    <div>
      <PageHeader title="Statistics & Charts" sub="Counts use verified unique participants per meeting (Present or Late) unless you choose another status. Updated automatically." />
      <Filters f={f} setF={setF} dir={dir} meetings={meetings} />
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        <StatCard testid="ov-meetings" label="Meetings" value={d.meetings_count} />
        <StatCard testid="ov-attendances" label={f.status ? `${f.status} records` : "Verified attendances"} value={d.attendances} />
        <StatCard testid="ov-unique" label="Unique persons" value={d.unique_people} />
        <StatCard testid="ov-parish" label="Parish / External" value={`${d.parish} / ${d.external}`} />
        <StatCard testid="ov-pending" label="Pending verification" value={d.pending} />
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        <ChartBox title="Attendance by Zone" testid="ov-chart-zone"><VBar data={d.by_zone} /></ChartBox>
        <ChartBox title="Parish vs External Guests" testid="ov-chart-donut"><Donut parish={d.parish} external={d.external} /></ChartBox>
        <ChartBox title="Attendance by GKK" note="Top 15" height={360} testid="ov-chart-gkk"><HBar data={d.by_gkk} /></ChartBox>
        <ChartBox title="Attendance by Ministry Represented" height={360} testid="ov-chart-ministry"><HBar data={d.by_ministry} color="#C85A32" /></ChartBox>
        <ChartBox title="Attendance by Position" testid="ov-chart-position"><VBar data={d.by_position} color="#5C3A21" /></ChartBox>
        <ChartBox title="Monthly Attendance Trend" testid="ov-chart-monthly"><TrendLine data={d.monthly} /></ChartBox>
        <div className="lg:col-span-2"><ChartBox title="Actual vs Expected Attendance" testid="ov-chart-expected"><ExpectedBars data={d.expected_vs_actual} /></ChartBox></div>
      </div>
      <GroupTrends />
    </div>
  );
}
